import { render } from "./TranslationKeyField.vue?vue&type=template&id=2647b2cc&scoped=true"
import script from "./TranslationKeyField.vue?vue&type=script&lang=js"
export * from "./TranslationKeyField.vue?vue&type=script&lang=js"

import "./TranslationKeyField.vue?vue&type=style&index=0&id=2647b2cc&scoped=true&lang=css"

import exportComponent from "/home/gp/git/git.glitchedpolygons.ch/locales.glitchedpolygons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2647b2cc"]])

export default __exports__